<template>
<div class="reset-page">
    <div class="page-inner">
        <button class="back-btn" type="button" @click="goBack">
            <span class="back-arrow" aria-hidden="true">←</span>
            <span>返回</span>
        </button>

        <el-card class="card" shadow="never">
            <span class="title">重置密码</span>
            <div class="item-column">
                <span class="span-hint" v-show="!phone_status">{{phone_hint}}</span>
                <el-input placeholder="请输入手机号" size="medium" v-model="phone" @blur='phoneOnBlur' maxlength=11 @keyup.enter.native="setPasswordConfirm" clearable></el-input>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!verify_status">{{verify_hint}}</span>
                <div class="item-row">
                    <el-input placeholder="输入验证码" size="medium" v-model="verify_code" @blur='verifyOnBlur' @keyup.enter.native="setPasswordConfirm" maxlength=11 clearable></el-input>
                    <el-button class="btn-verify" size="medium" @click="getVerifyCode" type="primary" :disabled="verify_disable">{{btn_verify}}</el-button>
                </div>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!password_status">{{password_hint}}</span>
                <el-input placeholder="字母和数字组合，最少6位" size="medium" v-model="password" @blur='passwordOnBlur' @keyup.enter.native="setPasswordConfirm" maxlength=20 show-password></el-input>
            </div>
            <div class="item-column item-column-action">
                <el-button class="btn-confirm" size="medium" type="primary" @click="setPasswordConfirm">确 定</el-button>
            </div>
        </el-card>
    </div>
</div>
</template>
<script>
export default {
    data () {
        return {
            phone_hint:'请输入手机号',
            phone_status:true,
            phone:'',
            verify_hint:'请输入验证码',
            verify_status:true,
            verify_code:'',
            password_hint:'请输入密码',
            password_status:true,
            password:'',
            btn_verify:'获取验证码',
            verify_disable:false,
            verify_second:60,
        }
    },
    methods:{
        goBack(){
            if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
                this.$router.go(-1)
            }else{
                this.$router.replace('/')
            }
        },
        getVerifyCode(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请先填写手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请先填写正确的手机号',
                    type: 'fail'
                });
                return
            }
            var codeParams = {
                telephone:this.phone,
                phoneMd5:this.$md5(this.phone),
                type:'resetpwd'
            }
            this.wjtHttp.get(this,'/api/smsCode',codeParams,false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message:'发送成功',
                        type:'success'
                    })
                    this.verify_disable = true
                    clearInterval(this.mInterval)
                    this.mInterval = setInterval(() => {
                        if(this.verify_second == 0){
                            this.verify_disable = false
                            this.verify_second = 60
                            clearInterval(this.mInterval)
                            return
                        }
                        this.verify_second--
                    }, 1000);
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            })
        },
        phoneOnBlur(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
            }else if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
            }else{
                this.phone_status = true
            }
        },
        verifyOnBlur(){
            if(this.verify_code.length == 0){
                this.verify_status = false
                this.verify_hint='请输入验证码'
            }else{
                this.verify_status = true
            }
        },
        passwordOnBlur(){
            if(this.password.length == 0){
                this.password_status = false
                this.password_hint='请输入密码'
            }else if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.password_status = false
                this.password_hint = '密码须为字母和数字组合，最少6位'
            }else{
                this.password_status = true
            }
        },
        setPasswordConfirm(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请输入手机号',
                    type: 'warning'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'warning'
                });
                return
            }
            if(this.password.length == 0){
                this.$message({
                    message: '请输入密码',
                    type: 'warning'
                });
                return
            }
            if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.$message({
                    message: '密码须为字母和数字组合，最少6位',
                    type: 'warning'
                });
                return
            }
            if(this.verify_code.length == 0){
                this.$message({
                    message: '请输入验证码',
                    type: 'warning'
                });
                return
            }
            var vParams = {
                code:this.verify_code,
                username:this.phone,
                phoneMd5:this.$md5(this.phone),
                password:this.password
            }
            this.wjtHttp.post(this,'/api/resetPwd',vParams,false,(res)=>{
                    var data = res.data
                    if(data.code == 200){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
                            this.$router.go(-1)
                        }else{
                            this.$router.replace('/')
                        }
                    }else{
                        this.$message({
                            message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                            type:'error'
                        })
                    }
                })
        }

    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    },
    watch:{
        verify_disable:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        verify_second:function(val){
            if(val < 60){
                this.btn_verify = val + '后重发'
            }
        },
        login_type:function(val){
            if(val == 'verify'){
                this.login_change_text = '密码登录'
            }else{
                this.login_change_text = '忘记密码？'
            }
        }
    }
}
</script>
<style scoped>
    /* ===== 重置密码：整屏上下左右居中 ===== */
    .reset-page {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 48px 24px;
        background: #f5f7f2;
        box-sizing: border-box;
    }

    .page-inner {
        position: relative;
        width: 100%;
        max-width: 470px;
    }

    /* 返回按钮 */
    .back-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 42px;
        padding: 0 20px;
        margin-bottom: 16px;
        border: 1px solid #d3e6e3;
        border-radius: 10px;
        background: #fff;
        color: #304744;
        font-family: inherit;
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .back-btn:hover {
        border-color: #009798;
        color: #009798;
    }

    .back-arrow {
        color: #009798;
        font-weight: 700;
    }

    .card {
        width: 100%;
        margin: 0 auto;
        padding: 38px 38px 36px;
        background-color: #fff;
        border: 1px solid #e9efec;
        border-radius: 18px;
        box-shadow: 0 14px 40px rgba(23, 61, 59, 0.08);
        box-sizing: border-box;
    }

    .card>>>.el-card__body {
        padding: 0;
    }

    .title {
        display: block;
        margin-bottom: 32px;
        font-size: 30px;
        font-weight: 700;
        color: #304744;
        letter-spacing: 1px;
    }

    .span-hint {
        font-size: 18px;
        color: #ff5a05;
        padding-bottom: 8px;
        text-align: left;
    }

    .item-column {
        display: flex;
        flex-direction: column;
        margin-bottom: 26px;
    }

    .item-column-action {
        margin-top: 8px;
        margin-bottom: 0;
    }

    .item-row {
        display: flex;
        flex-direction: row;
    }

    .item-row>>>.el-input {
        flex: 1;
        min-width: 0;
    }

    .btn-verify {
        flex-shrink: 0;
        height: 52px;
        margin-left: 12px;
        border-radius: 10px;
        font-size: 18px;
        font-weight: 600;
    }

    .btn-confirm {
        width: 100%;
        height: 52px;
        border-radius: 10px;
        font-size: 19px;
        font-weight: 700;
    }

    .card>>>.el-input__inner {
        height: 52px;
        line-height: 52px;
        border-radius: 10px;
        border-color: #d3e6e3;
        color: #304744;
        font-size: 18px;
    }

    .card>>>.el-input__inner:focus {
        border-color: #009798;
    }

    .card>>>.el-input__icon {
        line-height: 52px;
        font-size: 18px;
    }

    @media (max-width: 768px) {
        .reset-page {
            align-items: flex-start;
            padding: 24px 16px;
        }

        .card {
            padding: 24px 20px;
        }
    }
</style>
